// extracted by mini-css-extract-plugin
export default {"container":"VcKnT_","headerCont":"jNiOG6","header":"u4imFF","content":"Zm7xVP","controls":"qhIlRn","signUpButton":"ddW8xC","mobile":"JsXH7u","desktop":"SrGJS1"};